import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import GlobalURL from "../baseUrl";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { IoIosSearch } from "react-icons/io";
import BootTable from "../components/bootTable";
import "./pstyle.css";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";
import {
  performVerification,
  tokenVerification,
} from "../commonFunc/verification";
import { LuCircleChevronLeft } from "react-icons/lu";
import { useSelector } from "react-redux";
import translations from "../locals/translation";
import { useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

function Reqlist() {
  const state = useLocation();
  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const navigate = useNavigate();
  const [loading1, setLoading1] = useState(true);

  const [password, setPassword] = useState("");
  const [reason, setReason] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [show, setShow] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showReas, setShowReas] = useState(false);
  const handleClose = () => setShow(false);
  const [setData] = useState([]);
  const [originalData] = useState([]);

  const [idDel] = useState("");
  const [ueload, setUeload] = useState(false);

  const [pendingtableData, setPendingtableData] = useState([]);
  const [approvedtableData, setApprovedtableData] = useState([]);
  const [rejectedtableData, setRejectedtableData] = useState([]);

  const useFunction = async () => {
    if (state.state == null || state.state === undefined) {
      // navigate('/dashboard');
      return;
    }
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    setShowPass(false);
    const requestData = {
      truck_id: idDel,
      password: password,
    };

    try {
      const url = `${GlobalURL}/api/dev/admin/deleteTruck`;
      const headers = {
        "Content-Type": "application/json",
        lang_id: language,
        token: `${Newtoken}`,
        "ngrok-skip-browser-warning": "69420",
      };

      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          if (data.status_code === 200) {
            Swal.fire(data.message);
          } else if (data.status_code === 404) {
            Swal.fire(data.message);
          } else if (data.status_code === 400) {
            Swal.fire(data.message);
          } else if (data.status_code === 401) {
            Swal.fire(data.message);
          } else {
            Swal.fire(t("Server Error"));
          }

          if (data.status_code !== 200) {
            Swal.fire("Error", data.message, "error");
            return;
          }

          setShowPass(false);
          Swal.fire(data.message);
          setUeload(!ueload);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
          Swal.fire(t("Server Error"));
        });
    } catch (error) {
      console.log(error);
    }
  };
  const suspendContinue = async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    if (!reason) {
      Swal.fire({
        title: t("Justification!"),
        text: t("Justification Required"),
        icon: "error",
      });
      return;
    }
    setShowReas(false);
    const url = `${GlobalURL}/api/dev/admin/suspendTruck`;

    const headers = {
      "Content-Type": "application/json",
      lang_id: language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };

    const requestData = {
      truck_id: idDel,
      message: reason,
    };

    try {
      const response = await fetch(url, {
        method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
        mode: "cors",
        headers,
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.status_code === 200) {
        Swal.fire({ text: data.message, icon: "success" });
      } else if (data.status_code === 404) {
        Swal.fire(data.message);
      } else if (data.status_code === 400) {
        Swal.fire(data.message);
      } else if (data.status_code === 401) {
        Swal.fire(data.message);
      }
      setReason("");
      setUeload(!ueload);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleSearchChange = (e) => {
    let data3 = originalData;
    const inputValue = e.target.value.toLowerCase();
    if (inputValue === "") {
      setData(originalData);
      setSearchInput("");
      return;
    }
    const result = data3.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(inputValue)
      )
    );

    if (result.length === 0) {
      setData([]);
    }
    setSearchInput(inputValue);
    setData(result);
  };
  const fetchImageStatusList = async () => {
    const token = localStorage.getItem("token");
    const langId = localStorage.getItem("lang");
    try {
      const response = await fetch(
        `${GlobalURL}/api/dev/admin/getImageStatusList`,
        {
          method: "GET",
          headers: {
            "Content-Type": "Application/JSON",
            "ngrok-skip-browser-warning": "69420",
            token: token,
            lang_id: langId,
          },
        }
      );
      const data = await response.json();

      if (data.status_code === 200) {
      }
      const pD = data.data.filter((item) => item.avatar_approved === 1);
      setPendingtableData(pD);
      const aD = data.data.filter((item) => item.avatar_approved === 2);
      setApprovedtableData(aD);
      const rD = data.data.filter((item) => item.avatar_approved === 3);
      setRejectedtableData(rD);
      setLoading1(false);
    } catch (error) {
      setLoading1(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
    }

    fetchImageStatusList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchImageStatusList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ueload]);

  return (
    <React.Fragment>
      <Header />
      <div className="login-heading">
        <h1 style={{ marginTop: "80px" }}>{t("Request List")}</h1>
        <h5>
          {t(
            "Vendors can upload avatars, but they will first be monitored by the admin and can be either rejected or approved."
          )}
        </h5>
        <div className="table-div-vendors">
          <div className="input-with-search">
            <div className="search-back">
              <LuCircleChevronLeft
                fill="none"
                className="back-button"
                onClick={() => navigate(-1)}
              />
              <div className="input-with-search">
                <input
                  placeholder={t("search")}
                  value={searchInput}
                  onChange={(e) => {
                    handleSearchChange(e);
                  }}
                  style={{ opacity: "0" }}
                  disabled={true}
                  className="searchInput"
                />
                <IoIosSearch style={{ opacity: "0" }} />
              </div>
            </div>
          </div>

          <div className="table-container">
            <div className="add-butto-div"></div>

            <Tabs
              defaultActiveKey="Pending"
              id="uncontrolled-tab-example"
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "40px",
                borderBottomColor: "transparent",
                padding: "0px",
              }}
            >
              <Tab eventKey="Pending" title={t("Pending")}>
                {loading1 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="loading-spinner"></div>
                    <p className="logging-heading">{t("Loading")}</p>
                  </div>
                ) : (
                  <BootTable
                    status={ueload}
                    setStatus={setUeload}
                    tableData={pendingtableData}
                  />
                )}
              </Tab>

              <Tab eventKey="Rejected" title={t("Rejected")}>
                {loading1 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="loading-spinner"></div>
                    <p className="logging-heading">{t("Loading")}</p>
                  </div>
                ) : (
                  <BootTable
                    status={ueload}
                    setStatus={setUeload}
                    tableData={rejectedtableData}
                  />
                )}
              </Tab>

              <Tab eventKey="Approved" title={t("Approved")}>
                {loading1 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="loading-spinner"></div>
                    <p className="logging-heading">{t("Loading")}</p>
                  </div>
                ) : (
                  <BootTable
                    status={ueload}
                    setStatus={setUeload}
                    tableData={approvedtableData}
                  />
                )}
              </Tab>
            </Tabs>
          </div>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="loading-spinner"></div>{" "}
                <p className="logging-heading">{t("Loading")}</p>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showPass}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                {t("Password")}
              </Modal.Title>
              <label
                onClick={() => {
                  setShowPass(false);
                }}
              >
                X
              </label>
            </Modal.Header>
            <Modal.Body>
              <p>{t("Password Required For Authentiation")}</p>
              <input
                value={password}
                type="password"
                required
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={useFunction}>{t("Done")}</Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showReas}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                {t("Justification")}
              </Modal.Title>
              <label
                onClick={() => {
                  setShowReas(false);
                }}
              >
                X
              </label>
            </Modal.Header>
            <Modal.Body>
              <p>{t("Purpose Required For Suspention")}</p>
              <input
                value={reason}
                type="text"
                required
                onChange={(e) => {
                  setReason(e.target.value);
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  suspendContinue();
                }}
              >
                {t("Done")}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Reqlist;
